<div #container class="login-network-viz">
  <canvas #canvas class="login-network-viz__canvas"></canvas>
  <div
    *ngIf="tooltip"
    class="login-network-viz__tooltip"
    [style.left.px]="tooltip.leftPx"
    [style.top.px]="tooltip.topPx"
  >
    <div class="login-network-viz__tooltip-inner">
      <div class="login-network-viz__tooltip-name">
        {{ tooltip.advocate.name }}
        <span class="login-network-viz__tooltip-role">({{ tooltip.advocate.role }})</span>
      </div>
      <div class="login-network-viz__tooltip-stats">
        {{ tooltip.advocate.shares }} shares → {{ tooltip.advocate.regs }} registrations
      </div>
    </div>
  </div>
</div>
